export const styles = {
  container: {
    display: 'inline-flex',
    position: 'relative',
    width: '86px',
    height: '66px',
    borderRadius: '8px',
    border: '1px solid #F3F4F9',
    overflow: 'hidden',
    cursor: 'pointer',
  },
};
